<template>
  <div class="wallet">
    <div class="subheading grey--text mt-6 ml-6"><h5>Wallet vaults</h5></div>
    <div class="my-5 ml-3">
      <v-layout row>
        <v-flex xs4 md3 class="ml-3">
          <v-tooltip top
            ><template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="transact white--text lowercase-text"
                block
                plain
                @click="dialogs.deposit = true"
              >
                Deposit
              </v-btn> </template
            ><span>Fuel FlexiFund with M-Pesa deposit!</span></v-tooltip
          >
        </v-flex>
        <v-flex xs3 md3 class="ml-4">
          <v-tooltip top
            ><template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="primary white--text lowercase-text"
                block
                plain
                color="primary"
                @click="dialogs.withdraw = true"
                >Withdraw</v-btn
              ></template
            ><span>Tap to withdraw from FlexiFund.</span></v-tooltip
          >
        </v-flex>
      </v-layout>
    </div>
    <v-layout row wrap class="mt-8 mx-1">
      <TextPay />
      <FlexiFund />
      <QuickSwap />
      <ShareGain />
    </v-layout>
    <WalletExplanation class="mx-6" />

    <FlexiFundDeposit @close="dialogs.deposit = false" v-if="dialogs.deposit" />
    <FlexiFundWithdraw
      @close="dialogs.withdraw = false"
      v-if="dialogs.withdraw"
    />
  </div>
</template>

<script>
import FlexiFundDeposit from "@/components/wallet/FlexiFundDeposit";
import FlexiFundWithdraw from "@/components/wallet/FlexiFundWithdraw";
import TextPay from "@/components/wallet/TextPay";
import FlexiFund from "@/components/wallet/FlexiFund";
import QuickSwap from "@/components/wallet/QuickSwap";
import ShareGain from "@/components/wallet/ShareGain";
import WalletExplanation from "@/components/wallet/WalletExplanation";
export default {
  components: {
    FlexiFundDeposit,
    FlexiFundWithdraw,
    TextPay,
    FlexiFund,
    QuickSwap,
    ShareGain,
    WalletExplanation,
  },
  data() {
    return {
      dialogs: {
        deposit: false,
        withdraw: false,
      },
    };
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
.row-pointer {
  cursor: pointer;
  color: #2c5282;
}
.custom-card {
  /* Add your additional border radius values */
  border-radius: 20px;
}
</style>
